"use client";

import React from "react";
import { Truck, CircleDollarSign, ShieldCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "National Delivery",
  description: "Optimized logistics network across Australia, delivering heavy-duty building materials and hardware directly to your construction site or warehouse.",
  icon: Truck
}, {
  title: "Wholesale Solutions",
  description: "Strategic bulk pricing models designed for B2B procurement, ensuring high-volume orders remain cost-effective for large-scale infrastructure projects.",
  icon: CircleDollarSign
}, {
  title: "Standards Compliant",
  description: "All supplied materials undergo rigorous quality checks to ensure full compliance with Australian building codes and structural safety standards.",
  icon: ShieldCheck
}];
export default function PartnerWithUs() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="128991" id="operational-excellence" className="py-24 lg:py-32 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl leading-tight font-serif font-extrabold tracking-tight text-primary">
            Operational Excellence
          </h2>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full relative overflow-hidden border border-border shadow-sm hover:shadow-xl hover:border-amber-500/50 transition-all duration-300 bg-card group rounded-md">
                  {}
                  <div className="absolute top-0 left-0 w-full h-1 bg-amber-500 transform origin-left scale-x-100 transition-transform duration-500 group-hover:scale-x-100" />
                  
                  <CardHeader className="pb-2 pt-10">
                    <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-sm bg-amber-500/10 text-amber-600 group-hover:bg-amber-500 group-hover:text-white transition-all duration-300">
                      <Icon className="w-7 h-7" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-serif text-2xl font-bold text-primary tracking-tight">
                      {pillar.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="font-sans text-muted-foreground leading-relaxed text-base">
                      {pillar.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}